import React, { useState } from 'react';
import { Pressable, StyleSheet } from 'react-native';

import GridIcon from '@/assets/icons/grid-view';
import ListIcon from '@/assets/icons/list-view';
import { LineSeparator } from '@/components/LineSeparator';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';
import { isWeb } from '@/utils/constants-platform-specific';

import { CasinoLayoutProps } from '../../utils/utils';
import { FeaturedGridLayout } from './FeaturedGridLayout';
import { VerticalListLayout } from './VerticalListLayout';

type LayoutType = 'grid' | 'list';

export const GridListToggleLayout = ({ data, layoutHeaderProps, isFetchingNextPage = false }: CasinoLayoutProps) => {
    const [activeLayout, setActiveLayout] = useState<LayoutType>('grid');

    const handleLayoutToggle = (layout: LayoutType) => {
        setActiveLayout(layout);
    };

    const isGridActive = activeLayout === 'grid';
    const isListActive = activeLayout === 'list';

    const gridIconColor = isGridActive ? ds.colorValue.icon.primary : designSystem.colors.neutral300;
    const listIconColor = isListActive ? ds.colorValue.icon.primary : designSystem.colors.neutral300;

    return (
        <Box>
            <Box px={isWeb ? 's0' : 's16'} py="s16">
                <Row alignItems="center">
                    <Text
                        color={ds.colorToken.text.primary}
                        variant="headlineSmall"
                        fontWeight="bold"
                        letterSpacing={-0.45 / 20}
                    >
                        {layoutHeaderProps?.title}
                    </Text>
                    <Pressable onPress={() => handleLayoutToggle('grid')}>
                        <Box pl="s16" pr="s8">
                            <GridIcon width={20} height={20} color={gridIconColor} />
                        </Box>
                    </Pressable>
                    <LineSeparator vertical style={styles.lineSeparator} />
                    <Pressable onPress={() => handleLayoutToggle('list')}>
                        <Box pl="s8">
                            <ListIcon width={20} height={20} color={listIconColor} />
                        </Box>
                    </Pressable>
                </Row>
            </Box>

            {activeLayout === 'grid' ? (
                <FeaturedGridLayout data={data} isFetchingNextPage={isFetchingNextPage} />
            ) : (
                <Box px={isWeb ? 's0' : 's16'}>
                    <VerticalListLayout data={data} />
                </Box>
            )}
        </Box>
    );
};

const styles = StyleSheet.create({
    lineSeparator: {
        height: 16,
    },
});
